/**
 * @flow
 * Created by neo on 18.02.17.
 */

import {observable, action, computed} from 'mobx';
import BackendFactory from "../../Services/BackendFactory";

type AircraftType = {
  id: number,
  name: string
}

export default class Aircraft {
  @observable id: string;
  @observable name: string;
  @observable description: string;
  @observable useful_load: number;
  @observable weight_max: number;
  @observable passengers_capacity: number;
  @observable weight_empty: number;
  @observable weight_fuel_max: number;
  @observable range: number;
  @observable type: AircraftType = {};
  @observable files: Array<any> = [];
  @observable _isNew = true;

  constructor(json: any) {
    if(json) {
      this.id = json.id;
      this.name = json.name;
      this.description = json.description || '';
      this.useful_load = json.useful_load;
      this.weight_max = json.weight_max;
      this.passengers_capacity = json.passengers_capacity;
      this.weight_empty = json.weight_empty;
      this.weight_fuel_max = json.weight_fuel_max;
      this.range = json.range;
      this.type = json.type || { id: 2, name: 'helicopter' };
      this.files = json.files || [];
    }
  }

  @computed get maxPassengers(): number {
    return this.passengers_capacity || 0;
  }

  static async list() {
    const backend = await BackendFactory();
    const res = await backend.get('/aircrafts');
    let aircrafts = res.data.map(a => new Aircraft(a));
    return aircrafts;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Aircraft/index.js